import { useEffect, useState } from "react";
import { CapeMark } from "./Logo";

const LINKS = [
  { label: "Origins", href: "origins" },
  { label: "Chapters", href: "chapters" },
  { label: "The Film", href: "film" },
  { label: "Craft", href: "craft" },
  { label: "Legacy", href: "legacy" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-xl border-b border-gold/15"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" onClick={go("top")} data-testid="header-logo-link" className="flex items-center gap-3">
          <CapeMark size={30} />
          <span className="font-display text-sm tracking-[0.22em] text-cream sm:text-base">
            HILMAY&rsquo;S KABAS
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={`#${l.href}`}
              onClick={go(l.href)}
              data-testid={`nav-${l.href}`}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-stone2 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
